import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import '../Pages/Commercial.css';
import ComBan from "../Components/ComBan";
import SEO from "../Components/SEO";
import { FaBuilding, FaWarehouse, FaStore, FaBriefcase, FaMapMarkerAlt, FaTags } from "react-icons/fa";
import AOS from "aos";
import 'aos/dist/aos.css';

const commercialProjects = [
  {
    name: "VARK Tech Hub",
    location: "Bypass Road, Madurai",
    category: "Corporate IT Park",
    status: "Completed",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80"
  },
  {
    name: "VARK Trade Center",
    location: "Mattuthavani, Madurai",
    category: "Commercial Complex",
    status: "Completed",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=800&q=80"
  },
  {
    name: "VARK Business Tower",
    location: "Anna Nagar, Madurai",
    category: "Executive Offices",
    status: "Ongoing",
    image: "https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&w=800&q=80"
  },
  {
    name: "VARK Logistics Park",
    location: "Othakadai, Madurai",
    category: "Industrial Warehousing",
    status: "Completed",
    image: "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=800&q=80"
  }
];

export default function Commercial() {
  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({ duration: 1000, once: true });
  }, []);

  const services = [
    { icon: <FaBuilding />, title: "IT Parks & Offices", desc: "State-of-the-art corporate environments with smart infrastructure." },
    { icon: <FaStore />, title: "Retail & Malls", desc: "Attractive and functional spaces for retail success." },
    { icon: <FaWarehouse />, title: "Industrial Units", desc: "Heavy-duty structures designed for industrial efficiency." },
    { icon: <FaBriefcase />, title: "Business Centers", desc: "Modern hubs for growing businesses and startups." },
  ];

  return (
    <div className="commercial-page">
      <SEO 
        title="Commercial Projects" 
        description="Explore commercial office complexes, IT parks, retail malls, and industrial units built by VARK Builders Private Limited."
      />
      <ComBan />
      
      <section className="com-intro">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <span className="subtitle">Corporate Solutions</span>
            <h2>Building for <span>Business</span></h2>
            <p>From modern offices to high-scale industrial complexes, we build the future of business.</p>
          </div>
          
          <div className="com-services-grid">
            {services.map((item, index) => (
              <div className="com-service-card" key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Commercial Project Showcase Section */}
      <section className="com-projects-section">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <span className="subtitle">Our Showcase</span>
            <h2>Commercial <span>Projects</span></h2>
            <p>Explore our track record of state-of-the-art commercial construction projects across Tamil Nadu.</p>
          </div>

          <div className="com-projects-grid">
            {commercialProjects.map((project, index) => (
              <div 
                className="com-project-card" 
                key={index} 
                data-aos="fade-up" 
                data-aos-delay={index * 120}
              >
                <div className="project-img-box">
                  <img src={project.image} alt={project.name} loading="lazy" />
                  <span className={`status-tag ${project.status.toLowerCase()}`}>
                    {project.status}
                  </span>
                </div>
                <div className="project-info-box">
                  <h3>{project.name}</h3>
                  <div className="info-row">
                    <span className="info-item"><FaTags /> {project.category}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-item"><FaMapMarkerAlt /> {project.location}</span>
                  </div>
                  <div className="com-card-actions">
                    <Link to="/contact" className="com-action-btn font-oswald">Request Case Study</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="com-expertise">
        <div className="container">
          <div className="expertise-wrap">
            <div className="expertise-text" data-aos="fade-right">
              <h2>Our Commercial <span>Expertise</span></h2>
              <p>
                Commercial construction requires a different set of engineering practices. 
                At VARK Builders, we focus on load-bearing capacity, safety compliance, 
                and energy-efficient infrastructure to ensure your business space is both 
                durable and operational.
              </p>
              <ul>
                <li>High-load structural engineering and framing</li>
                <li>Advanced HVAC systems & networking infrastructure</li>
                <li>Fire safety certifications and municipal clearance</li>
                <li>Smart energy-efficient layout design</li>
              </ul>
            </div>
            <div className="expertise-img" data-aos="fade-left">
              <img 
                src="https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&w=800&q=80" 
                alt="Commercial Expertise" 
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
